export const SET_ALERTS = "SET_ALERTS";
export const SET_ALERT = "SET_ALERT";
export const SET_IS_IN_AGENCY = "SET_IS_IN_AGENCY";
export const RESOLVE_SELECTED_ALERTS = "RESOLVE_SELECTED_ALERTS";
export const REJECT_SELECTED_ALERTS = "REJECT_SELECTED_ALERTS";
export const SET_CURRENT_ALERT = "SET_CURRENT_ALERT";
